import {
    SUB_PROFILE_RULES_FETCH,
    SUB_PROFILE_RULES_IS_FETCING,
    SUB_PROFILE_RULES_API,
    SUB_PROFILE_RULES_EDIT
} from 'constants/subProfileRules'

import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

export const subProfileRulesSave = (subProfileId, data) => (dispatch, state) => {
    let action;
    if (data.subProfileRuleId)
        action = put;
    else
        action = post;
    const url = `${SUB_PROFILE_RULES_API}/${subProfileId}/rules${data.subProfileRuleId? `/${data.subProfileRuleId}` : ''}`
    dispatch(subProfileRulesIsFetching(true))
    return action(url, data, true)
        .finally(e => dispatch(subProfileRulesIsFetching(false)))
}

export const subProfileRuleFetch = (subProfileId, id) => (dispatch, state) => {
        dispatch(subProfileRulesIsFetching(true));
        return get(SUB_PROFILE_RULES_API + '/' + subProfileId + '/rules/' + id)
            .finally(e => dispatch(subProfileRulesIsFetching(false)))
}

export const subProfileRulesFetch = (subProfileId) => (dispatch, state) => {
    dispatch(subProfileRulesIsFetching(true))
    return get(`${SUB_PROFILE_RULES_API}/${subProfileId}/rules`)
        .then((e) => {
            dispatch(subProfileRulesFetched(e))
            return e
        })
        .finally(e => dispatch(subProfileRulesIsFetching(false)))
}

//this fetch sub profile rules without updating redux store
export const subProfileRulesFetchHelper = (subProfileId) => (dispatch) => {
	dispatch(subProfileRulesIsFetching(true))
    return get(`${SUB_PROFILE_RULES_API}/${subProfileId}/rules`)
        .then((e) => {
            return e
        })
        .finally(e => dispatch(subProfileRulesIsFetching(false)))
}

export const subProfileRuleRemove = (subProfileId, id) => (dispatch, state) => {
    dispatch(subProfileRulesIsFetching(true))
    return remove(`${SUB_PROFILE_RULES_API}/${subProfileId}/rules/${id}`)
        .finally(e => dispatch(subProfileRulesIsFetching(false)))
}

export const subProfileRulesFetched = (payload) => ({ type: SUB_PROFILE_RULES_FETCH, payload: payload })
export const subProfileRulesIsFetching = (payload) => ({ type: SUB_PROFILE_RULES_IS_FETCING, payload: payload })
export const subProfileRuleEdit = (id, data) => ({ type: SUB_PROFILE_RULES_EDIT, payload: data })



// WEBPACK FOOTER //
// ./src/actions/subProfileRules.js